import { FieldType } from '../../shared/fields'
import { FilterFieldLayout } from '../../types'
import { getDefaultDataFieldLayout } from './getDefaultDataFieldLayout'

export type DataFieldCommonProps = ReturnType<
  typeof useDataFieldModel
>['commonProps']

export type UseDataFieldModelParams = {
  fieldLayout?: FilterFieldLayout
  type?: FieldType
  name?: string
  id?: string
  defaultLabel?: string
  disabled?: boolean
}

export const useDataFieldModel = ({
  fieldLayout,
  type,
  name,
  id,
  defaultLabel,
  disabled
}: UseDataFieldModelParams) => {
  const {
    datafield: dataFieldLayout = {},
    display_actions: displayActions = false
  } = fieldLayout || {}

  const { label: layoutLabel } = dataFieldLayout
  const label = layoutLabel || defaultLabel

  const commonProps = {
    id,
    name,
    label,
    autoComplete: 'off' as const,
    style: {
      paddingLeft: 48
    },
    heightClass: 'regular' as const,
    disabled
  }

  const defaultDataFieldLayout = getDefaultDataFieldLayout(type, name)

  const { component: defaultComponent, filteraction: defaultFilteraction } =
    defaultDataFieldLayout

  const { component: layoutComponent, filteraction: layoutFilteraction } =
    dataFieldLayout || {}

  const component = layoutComponent || defaultComponent
  const filteraction = layoutFilteraction || defaultFilteraction

  return {
    label,
    commonProps,
    component,
    filteraction,
    displayActions
  }
}
